import PropTypes from 'prop-types'
import { Select, SIZE } from 'baseui/select'
import { mergeOverrides } from 'baseui'
import { SDSelectOverrides } from './styled-components'
import { SDSelectPulseOverrides } from '@/shared/components/SDComponentsNewDesign/SDSelect/styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const SDSelect = ({ overrides, dataTestid, size = SIZE.compact, missing = false, ...rest }) => {
  const isPulse = usePulseScope()
  const newOverrides = mergeOverrides(isPulse ? SDSelectPulseOverrides(missing) : SDSelectOverrides(), overrides)
  const { id } = rest
  return (
    <Select
      {...rest}
      id={dataTestid || id}
      maxDropdownHeight='320px'
      labelKey='label'
      valueKey='label'
      size={size}
      overrides={newOverrides}
    />
  )
}

SDSelect.propTypes = {
  overrides: PropTypes.object,
  dataTestid: PropTypes.string,
  size: PropTypes.oneOf(Object.values(SIZE)),
  missing: PropTypes.bool,
}

export default SDSelect
